// @flow

import { setSelectedItemPath } from '../State/selectedItemPath';
import { setCurrentDirectoryPath } from '../State/currentDirectoryPath';
import { openFileViewerModal } from '../State/fileViewerModal';
import fetchDirectory from '../Services/fetchDirectory';
import downloadFile from '../Services/downloadFile';

const getFileExtension = (path: string) => {
  const parts = path.toLowerCase().split('.');
  return parts[parts.length - 1];
};

const getFileName = (path: string) => {
  const parts = path.split('/');
  return parts[parts.length - 1];
};

const isViewableFile = (path: string) => {
  const extension = getFileExtension(path);
  const viewableExtensions = ['pdf', 'png', 'jpg', 'jpeg', 'gif', 'bmp', 'webp', 'svg'];
  return viewableExtensions.includes(extension);
};

export default (type: string, path: string) => async (dispatch: Function) => {

  if (type === 'directory') {

    dispatch(setCurrentDirectoryPath(path))

    dispatch(setSelectedItemPath(null));

    dispatch(fetchDirectory())

  }

  if (type === 'file') {

    if (isViewableFile(path)) {
      dispatch(openFileViewerModal({
        filePath: path,
        fileName: getFileName(path)
      }));
    } else {
      dispatch(downloadFile(path));
    }
    
  }
}